<template>
  <div class="answers">
    <template v-if="answers.length">
      <Item
        v-for="answer in answers"
        v-bind:item="answer"
        v-bind:key="answer.id"
        v-on:onDelete="onDelete"
        v-on:onFavorite="onFavorite"
        v-on:onPlay="onPlay"
        ref="items"
      />
      <Pagination v-bind:pages="pages" v-on:onPaginate="onPaginate" />
    </template>
    <template v-else>
      <ItemEmpty />
    </template>
  </div>
</template>

<script>
import { adjust, findIndex, propEq, reject } from "ramda";
import _url from "url";
import { getUrl, updateHistory } from "../../helpers";
import Item from "./item.vue";
import ItemEmpty from "./item_empty.vue";
import Pagination from "./pagination.vue";

const PER_PAGE = 30;
const byId = propEq("id");
const toggleFavorite = (item) => ({
  ...item,
  favorite: !item.favorite,
});

export default {
  components: { Item, ItemEmpty, Pagination },
  props: ["initialAnswers", "initialPages", "answersEndpoint", "texts"],
  methods: {
    onDelete({ id, url }) {
      if (window.confirm(this.texts.youSure)) {
        this.answers = reject(byId(id), this.answers);
        let { current_page, total_pages } = this.pages;
        const willCurrentPageBeEmpty =
          current_page > 1 &&
          current_page === total_pages &&
          this.answers.length === 0;

        if (willCurrentPageBeEmpty) {
          current_page--;
          updateHistory(current_page, true);
        }

        this.$axios.delete(url).then(() => this.onPaginate(current_page));
      }
    },
    onFavorite({ id, url }) {
      const index = this.answers.findIndex(answer => answer.id === id);
      this.answers = adjust(index, toggleFavorite, this.answers);
      this.$axios.patch(url);
    },
    onPaginate(page) {
      const params = { page, per_page: getUrl().query.per_page || PER_PAGE };
      this.$axios.get(this.answersEndpoint, { params }).then((res) => {
        this.answers = res.data.data;
        this.pages = res.data.pages;
      }).catch((error) => {
        console.error('Error while loading pagination: ', error);
      });
    },
    onPlay(id) {
      this.$refs.items.forEach(({ item, stop }) => {
        if (item.id !== id) {
          stop();
        }
      });
    },
  },
  data() {
    return {
      answers: this.initialAnswers,
      pages: this.initialPages,
    };
  },
  provide() {
    return {
      texts: this.texts,
    };
  },
  mounted() {
    // Nur bei normaler Antwortenliste (nicht bei Favoriten) die Pagination initialisieren
    const urlParams = getUrl().query;
    const currentPage = urlParams.page || 1;
    
    // Prüfen ob es sich um die Favoriten-Ansicht handelt
    // Verwendet die lokalisierte Route aus I18n
    const favoritesPath = this.texts.favorites_route || 'favorites';
    const isFavoritesView = window.location.pathname.includes(`/${favoritesPath}`);

    if (!isFavoritesView) {
      this.onPaginate(currentPage);
    }
  },
};
</script>